<template lang='pug'>
    crud-form( submit-text='registrar' v-bind='formProps' @calculate='changeFieldValue' @submitForm='confirmSubmit' )
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
//
import { CrudForm } from '@/components/reusable_components'
//
import PurchaseInvoiceService from '@/services/api/purchase/purchase-invoice'
import CostCenterService from '@/services/api/accounting/cost-center'
import PaymentConditionService from '@/services/api/purchase/payment-condition'
import ProviderService from '@/services/api/purchase/provider'
//
import dateRule from './rules/date'
//
export default {
    components: {
        CrudForm,
    },
    computed: {
        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        formProps() {
            return {
                customRules: {
                    dateRule,
                },
                fields: this.fields,
            }
        },
    },
    data() {
        return {
            fields: PurchaseInvoiceService.fieldsRegistry,
            invoiceData: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },

        /**
         *
         */
        changeFieldValue({ field, value }) {
            switch (field) {
                case 'pch_provider_id':
                    this.setFieldOptionsData(
                        2,
                        this.fields[1].options.data.find(
                            ({ id }) => id === value
                        ).pch_provider_branch_offices
                    )
                    break
            }
        },

        /**
         *
         */
        confirmSubmit(event) {
            this.setInvoiceData(event)
            this.resetSnackbarState()
            this.setMessageConfirmSnack('crear factura')
            this.initSnackbar(
                this.fillSnack(
                    'warning',
                    'Factura',
                    '¿Estás seguro de crear la Factura?'
                )
            )
        },

        /**
         *
         */
        setFieldOptionsData(index, data) {
            this.fields[index].options.data = data
        },

        /**
         *
         */
        setInvoiceData(data) {
            this.invoiceData = data
            //console.log( data )
            //this.invoiceData.emission_date  = moment( data.emission_date, 'DD-MM-YYYY' ).format( 'YYYY-MM-DD' )
            //this.invoiceData.payment_date   = moment( data.payment_date, 'DD-MM-YYYY' ).format( 'YYYY-MM-DD' )
        },
    },
    watch: {
        /**
         *
         */
        async responseConfirm(val) {
            if (val === 'crear factura') {
                //
                const {
                    error,
                    message,
                    status,
                } = await PurchaseInvoiceService.create(this.invoiceData)

                //
                switch (status) {
                    case 'error':
                        this.resetSnackbarState()
                        this.showSnackbar('error', 'Error.', error || message)
                        break
                    case 'success':
                        this.resetSnackbarState()
                        this.showSnackbar(
                            'success',
                            'Factura registrada.',
                            message
                        )
                        this.$router.push({
                            name: 'purchase-invoices-paid-list',
                        })
                        break
                }
            }
        },
    },
    async beforeMount() {
        this.setTitleTopBar('Registro nueva factura')
        this.setFieldOptionsData(1, await ProviderService.fetchAll())
        this.setFieldOptionsData(5, await PaymentConditionService.fetchAll())
        this.setFieldOptionsData(6, await CostCenterService.fetchAll())
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_PURCHASE_INVOICE')) ctx.$router.push('/')
        })
    },
}
</script>